"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectionActions = void 0;
const react_1 = require("react");
const SelectionActionsContext_1 = __importDefault(require("./SelectionActionsContext"));
function useSelectionActions(dataType) {
    const actionsCtx = (0, react_1.useContext)(SelectionActionsContext_1.default);
    const setSelection = (0, react_1.useCallback)((items) => {
        actionsCtx.setSelection(dataType)(items);
    }, [actionsCtx, dataType]);
    const toggleSelection = (0, react_1.useCallback)((items, force) => {
        actionsCtx.toggleSelection(dataType)(items, force);
    }, [actionsCtx, dataType]);
    const clearSelection = (0, react_1.useCallback)(() => {
        actionsCtx.clearSelection(dataType)();
    }, [actionsCtx, dataType]);
    return {
        setSelection,
        toggleSelection,
        clearSelection,
    };
}
exports.useSelectionActions = useSelectionActions;
exports.default = useSelectionActions;
